import { Component, EventEmitter, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { GS1LoadingService, GS1NotificationService } from "@gs1france/gs1-components-library";
import { GLNService } from "src/app/core/services/gln/gln.service";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { Contact, ContactInfo, Gcps } from "src/app/models/contact.model";
import { addressValidator, GLN, GLNInterface, GLNStatus } from "src/app/models/gln.model";
import { RoleTypesList } from "../../../../config/role-types.config";
import { countryList } from "../../../../config/country-lists";
import { Language, LanguagesService } from "src/app/core/services/languages/languages.service";
import { environment } from '../../../../environments/environment';
import { OrganisationCodesList } from "../../../../config/orgnisation-code.config";
import { firstValueFrom } from "rxjs";
import { MapGeocoder } from "@angular/google-maps";


@Component({
  selector: 'creation-gln',
  templateUrl: './creation-gln.component.html',
  styleUrls: ['./creation-gln.component.scss'],
})
export class CreationGLNComponent implements OnInit, OnDestroy {
  GLNForm!: FormGroup;
  subs: any[] = [];
  allGlnTypes!: { value: string; label: string }[];
  sending: boolean = false;
  saving: boolean = false;
  countryList =  countryList.sort((a, b) => {
    if (a['wording-fr'] === 'France') {
      return -1;
    } else if (b['wording-fr'] === 'France') {
      return 1;
    } else {
      return a['wording-fr'].localeCompare(b['wording-fr']);
    }
  });
  roleTypesList = RoleTypesList;
  roleTypesListFilter = RoleTypesList.filter(
    (item) => item.id !== 'ISLocation' && item.id !== 'ISORGANIZATION'
  );
  organisationCode = OrganisationCodesList;
  contact!: ContactInfo;
  currentId: string = '';
  currentStatus: string = '';
  showForm: boolean = false;
  loadingGLN = false;
  gcps: Gcps[] = [];
  languages!: Language[];
  isMain = false;
  step1 = true;

  splittedGLN: string[] = [];
  glnRange: number = 10;
  glnSuffix: string = '';
  glnIsValid: boolean = false;
  timeout: any = null;
  glnIsUsed : any = false;
  streetNumber?: string;
  countryName?: string;
  lat?: string;
  lng?: string;
  forest: any = 'forest';
  glns: GLNInterface[] = [];
  glnsFormated: GLNInterface[] = [];

  isorganization: boolean = false;
  islocation: boolean = false;
  isMobilePhysical: boolean = false;
 environment:string=environment.env;
 selectedItem: GLNInterface | undefined ;

  /**
   * The current GLN that the user is creating.  This is used to determine if the user is
   * editing a GLN or creating one.
   */
  @Input() currentGln?: GLNInterface | undefined;

  constructor(
    private glnService: GLNService,
    private _languages: LanguagesService,
    private fb: FormBuilder,
    private loading: GS1LoadingService,
    private notifications: GS1NotificationService,
    private router: Router,
    private storage: StorageService
    ,
    private _geoCoder: MapGeocoder,

  ) {}

  /**
   * Initializes the form and sets up the form controls.
   * @returns None
   */
  async ngOnInit() {

    this.languages = this._languages.getLanguagesList();
    this.glns = await this.storage.getGLNs();
    this.glnsFormated= this.glns.map((item) => ({
      ...item,
      name: item.name +" </br> "+"GLN"+ (item.gln ? " " + item.gln : ""),
    }));
    await this.createForm();
    if (this.currentGln) {
      this.updateFormwithGLN(this.currentGln);
    } else {
      this.showForm = true;
    }


  }
  getLabel(item: any): string {
    return item.name; // Replace this with your logic to generate the label
  }

  /**
   * Unsubscribes from all subscriptions.
   * @returns None
   */
  ngOnDestroy(): void {
    for (const sub of this.subs) {
      if (sub) sub.unsubscribe();
    }
  }
  getFormattedText(item: GLNInterface): string {
    if (this.selectedItem && item.id === this.selectedItem.id) {
      if(item.name ===undefined)
      return ''
      const selected = item.name.replace(/<br>/g, '').replace(/<\/br>/g, '').replace(/\n/g, '');
      return  selected ;
    } else {
      return item?.name===undefined? '' :item?.name;
    }
  }

  onSelect(value: GLNInterface): void {
    this.selectedItem = this.glnsFormated.find(item => item.id === value);
  }

  onCheckboxChange(event: any) {
    const addressFormGroup = this.GLNForm.get('address') as FormGroup;
       const postalCodeControl = addressFormGroup.get('postalCode');
       const streetAddressControl = addressFormGroup.get('streetAddress');
       const addressLocalityControl = addressFormGroup.get('addressLocality');
       const countryCodeControl = addressFormGroup.get('countryCode');
      if (event === true) {
       const glnTypeFormGroup =  this.GLNForm.get('glnType') as FormGroup;
       const physicalControl =  glnTypeFormGroup.get('isFixedPhysicalLocation');
       const functionControl = glnTypeFormGroup.get('isFunction');
       const digitalControl = glnTypeFormGroup.get('isDigitalLocation');

       if (physicalControl instanceof FormControl && functionControl instanceof FormControl && digitalControl instanceof FormControl) {
         const physicalCheckbox = physicalControl as unknown as HTMLInputElement;
         const functionCheckbox = functionControl as unknown as HTMLInputElement;
         const digitalCheckbox = digitalControl as unknown  as HTMLInputElement;

         physicalCheckbox.checked = false;
         functionCheckbox.checked = false;
         digitalCheckbox.checked = false;

        this.GLNForm.get('digitalAddress')?.clearValidators();
        this.GLNForm.get('digitalAddress')?.updateValueAndValidity();
       }

      if (postalCodeControl && streetAddressControl && addressLocalityControl && countryCodeControl) {
        postalCodeControl.clearValidators();
        streetAddressControl?.clearValidators();
        addressLocalityControl?.clearValidators();
        countryCodeControl?.clearValidators();

        postalCodeControl.updateValueAndValidity();
        streetAddressControl.updateValueAndValidity();
        addressLocalityControl.updateValueAndValidity();
        countryCodeControl.updateValueAndValidity();

        addressFormGroup.clearValidators();
        addressFormGroup.updateValueAndValidity();

         this.GLNForm.updateValueAndValidity();

       } else {
        console.log('nested Address Control not found.');
      }
    } else {
      if (postalCodeControl && streetAddressControl && addressLocalityControl && countryCodeControl) {
        postalCodeControl.addValidators([Validators.maxLength(9), Validators.required]);
        streetAddressControl?.addValidators([Validators.maxLength(80),Validators.required]);
        addressLocalityControl?.addValidators([Validators.maxLength(50),Validators.required]);
        countryCodeControl?.addValidators(Validators.required);

        postalCodeControl.updateValueAndValidity();
        streetAddressControl.updateValueAndValidity();
        addressLocalityControl.updateValueAndValidity();
        countryCodeControl.updateValueAndValidity();

        addressFormGroup.addValidators([addressValidator, Validators.required]);
        addressFormGroup.updateValueAndValidity();

         this.GLNForm.updateValueAndValidity();

       }
    }
  }

  /**
   * Checks if the user has a valid GCP licence key to create his GLN.
   * @returns {boolean} - True if the user has a valid GCP licence key.
   */
  hasUsableGCP() {
    return !!this.GLNForm.get('licenceKey')?.value;
  }

  hasOnlyCNUD() {
    return this.contact.hasOnlyCNUD;
  }
  /**
   * Creates the form for the GLN.
   * @returns None.
   * @returns None
   */
  async createForm() {
    this.contact = await this.storage.getContactInfo();
    this.gcps = this.contact.gcps.filter((item) => item.key !== '302564');
    if (this.contact) {
      this.GLNForm = this.fb.group({
        gln: [this.currentGln?.gln || null, null],
        licenceKey: [
          this.currentGln?.licenceKey ||
            this.gcps.filter((gcp) => gcp.value)[0]?.key ||
            null,
          Validators.required,
        ],
        glnType: new FormGroup(
          {
            isLegalEntity: new FormControl(false, null),
            isFixedPhysicalLocation: new FormControl(false, null),
            isMobilePhysicalLocation: new FormControl(false, null),
            isDigitalLocation: new FormControl(false, Validators.required),
            isFunction: new FormControl(false, null),

          },
          this.atLeastOne()
        ),
        status: [this.currentGln?.status || null, null],
        id: [this.currentGln?.id, null],
        language: [this.currentGln?.language || 'fr', Validators.required],
        roleType: [this.currentGln?.roleType || null, null],
        name: [
          this.currentGln?.name || null,
          Validators.compose([
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(100),
          ]),
        ],
        parentOrganisationGLN: [
          this.currentGln?.parentOrganisationGLN || null,
          Validators.compose([
            Validators.pattern(/\d{13}/),
            Validators.max(9999999999999),
            Validators.maxLength(13),
            Validators.maxLength(13),
          ]),
        ],
        digitalAddress: [
          this.currentGln?.digitalAddress || null,
          Validators.compose([Validators.maxLength(80)]),
        ],
        address: new FormGroup(
          {

            postalName: new FormControl(
              this.currentGln?.address?.postalName || null,
              null
            ),
            addressLocality: new FormControl(
              this.currentGln?.address?.addressLocality || null,
              Validators.compose([
                Validators.maxLength(50),
                Validators.required,
              ])
            ),



            postalCode: new FormControl(
              this.currentGln?.address?.postalCode || null,
              Validators.compose([Validators.maxLength(9), Validators.required])
            ),
            streetAddress: new FormControl(
              this.currentGln?.address?.streetAddress || null,
              Validators.compose([
                Validators.maxLength(80),
                Validators.required,
              ])
            ),
            streetAddress2: new FormControl(
              this.currentGln?.address?.streetAddress2 || null,
              Validators.maxLength(80)
            ),
            countryCode: new FormControl(
              this.currentGln?.address?.countryCode || null,
              Validators.required
            ),
          },
          Validators.compose([addressValidator, Validators.required])
        ),
        url: [this.currentGln?.url || null, null],
        mobileLocationValue: new FormControl(null),

        contact: new FormGroup({
          lastName: new FormControl(
            this.currentGln?.contact?.lastName || null,
            Validators.maxLength(50)
          ),
          firstName: new FormControl(
            this.currentGln?.contact?.firstName || null,
            Validators.maxLength(50)
          ),
          email: new FormControl(
            this.currentGln?.contact?.email || null,
            Validators.email
          ),
          phone: new FormControl(
            this.currentGln?.contact?.phone || null,
            Validators.pattern(/\d{9,10}/)
          ),
        }),
        isPublished: [this.currentGln?.isPublished || false, null],
        glnSuffix: [this.splittedGLN[1] || '', null],
        organisationCode: [this.currentGln?.organisationCode || null, null],
        codeNumberSiret: [
          this.currentGln?.codeNumberSiret || null,
          Validators.compose([
            Validators.minLength(14),
            Validators.maxLength(14),
            Validators.pattern("^\\d+$"),
          ]),
        ],
        codeNumberIntern: [
          this.currentGln?.codeNumberIntern || null,
          Validators.compose([Validators.maxLength(14)]),
        ],
        codeNumber: [
          this.currentGln?.codeNumberSiret ||
            this.currentGln?.codeNumberIntern ||
            null,
        ],
      });
      this.subs.push(
        // Fetches the next GLN for the selected GCP
        this.GLNForm.get('licenceKey')?.valueChanges.subscribe(
          async (selectedGcp) => {
            if (
              this.contact.gcps.find(
                (gcp) => gcp.key === selectedGcp && gcp.value
              )
            ) {
              this.fetchNextGlnForGcp(selectedGcp);
            }
          }
        )
      );
      this.subs.push(
        // Change the requirement of the form if isDigitalLocation changes.
        this.GLNForm.get('glnType')
          ?.get('isDigitalLocation')
          ?.valueChanges.subscribe((value: boolean) => {
            this.islocation=value ||  this.GLNForm.get('glnType')?.get('isFixedPhysicalLocation')?.value;

            this.checkRoleType();

             if (value === true && !this.isMobilePhysical) {
              this.GLNForm.get('digitalAddress')?.addValidators(
                Validators.required
              );

            } else {
              this.GLNForm.get('digitalAddress')?.removeValidators(
                Validators.required
              );
            }
            this.GLNForm.get('digitalAddress')?.updateValueAndValidity();
            this.GLNForm.get('digitalAddress')?.hasValidator;
          })
      );



      this.subs.push(
        // Change the requirement of the form if isDigitalLocation changes.
        this.GLNForm.get('glnType')
          ?.get('isFixedPhysicalLocation')
          ?.valueChanges.subscribe((value: boolean) => {
            this.islocation=value ||  this.GLNForm.get('glnType')?.get('isDigitalLocation')?.value;

            this.checkRoleType();



          })
      );

      this.subs.push(
        this.GLNForm.get('glnType')
          ?.get('isFunction')
          ?.valueChanges.subscribe((value: boolean) => {
            this.isorganization=value ;
            this.checkRoleType();
          })
      );
    }
  }

  /**
   * Checks if the digital address field is required.
   * @returns {boolean} - True if the digital address field is required.
   */
  isDigitalAdressRequired() {
    return this.GLNForm.get('digitalAddress')?.hasValidator(
      Validators.required
    );
  }
  shouldShowCodeNumber(): boolean {
    const value: string =
      (this.GLNForm.get("organisationCode")?.value as string) || "";
    return value.length !== 0;
  }
    checkRoleType() {
    if (this.islocation && !this.isorganization) {
      this.roleTypesListFilter = this.roleTypesList.filter(
        (item) => item.id !== 'ISORGANIZATION'
      ).sort((a, b) => a.label.localeCompare(b.label));
    }
    else if (!this.islocation && !this.isorganization) {
      this.roleTypesListFilter = RoleTypesList.filter(
        (item) => item.id !== 'ISLocation' && item.id !== 'ISORGANIZATION'
      ).sort((a, b) => a.label.localeCompare(b.label));
    }
    else if (!this.islocation && this.isorganization) {
      this.roleTypesListFilter = RoleTypesList.filter(
        (item) => item.id !== 'ISLocation'
      ).sort((a, b) => a.label.localeCompare(b.label));
    }
    else {
      this.roleTypesListFilter = RoleTypesList.sort((a, b) => a.label.localeCompare(b.label));

    }
  }

  /**
   * Updates the form with the given GLN.
   * @param {GLNInterface} glnToUse - the GLN to use for the form.
   * @returns None
   */
  async updateFormwithGLN(glnToUse: GLNInterface) {
    this.GLNForm.patchValue(glnToUse);
    this.showForm = true;
  }

  /**
   * Fetch the next available GLN for the given GCP.
   * @param {string} gcp - the GCP to fetch the next GLN for.
   * @returns None
   */
  async fetchNextGlnForGcp(gcp?: string) {
    if (!gcp || (this.currentGln && this.currentGln.status !== 'DRAFT')) return;
    try {
      this.loadingGLN = true;
      const gln = (await this.glnService.getNextGLNForGCP(gcp))?.toString();
      if (!gln) {
        throw new Error('Aucun GLN reçu');
      }
      this.GLNForm.get('gln')?.setValue(gln);
      this.GLNForm.get('gln')?.updateValueAndValidity();
      this.splitGLN(gcp, gln);

      this.loadingGLN = false;
      return gln;
    } catch (err) {
      this.loadingGLN = false;
      throw err;
    }
  }

  /**
   * Splits the GLN into the licencekey, plage and control.
   * @param {string} gcp - the GCP of the GLN
   * @param {string} gln - the GLN to split
   * @returns None
   */
  splitGLN(gcp: string, gln: string) {
    const control = gln.charAt(12);
    const plage = gln.substring(gcp.length, 12);

    this.glnRange = 13 - gcp.length - 1;
    this.splittedGLN = [gcp, plage, control];
    this.glnSuffix = plage;
    this.glnIsValid = true;
  }

  /**
   * Checks if the given control has the given error.
   * @param {string} controlName - the name of the control to check
   * @param {string} [error] - the error to check for.
   * @returns {boolean} - true if the control has the given error, false otherwise.
   */
  showError(controlName: string, error?: string): boolean {
    const control = this.GLNForm.get(controlName);
    if (!control || !control.errors || !(control.dirty || control.touched)) {
      return false;
    }
    if (!error) {
      return !control.valid;
    }
    return control.hasError(error);
  }

  /**
   * Returns the state of the address field.
   * @returns {[string, string]} - The icon and color to display.
   */
  getAdressState(): [string, string] {
    const controlPhysicalAddress = this.GLNForm.get('address');
    const controlDigitalAddress = this.GLNForm.get('digitalAddress');

    if (!!controlPhysicalAddress && !!controlDigitalAddress) {
      const errors = controlPhysicalAddress.errors;
      if (
        (controlPhysicalAddress.errors && controlPhysicalAddress.value) ||
        (controlDigitalAddress.errors && controlDigitalAddress.value)
      ) {
        return ['x-circle-fill', 'danger'];
      }
      if (controlPhysicalAddress.valid && controlDigitalAddress.valid) {
        return ['check-circle-fill', 'forest'];
      }
    }
    return ['exclamation-circle-fill', 'blue'];
  }

  /**
   * Returns the state of the form part.
   * @returns {[string, string]} - The icon and color to display.
   */
  getGLNInfosState(): [string, string] {
    const parent = this.GLNForm.get('parentOrganisationGLN');
    const types = this.GLNForm.get('glnType');
    const name = this.GLNForm.get('name');
    const role = this.GLNForm.get('roleType');
    if (parent && types && name && role) {
      if (
        (parent.errors && parent.value) ||
        (types.errors && types.value && types.dirty) ||
        (name.errors && name.value) ||
        (role.errors && role.value)
      ) {
        return ['x-circle-fill', 'danger'];
      }
      if (parent.valid && types.valid && name.valid && role.valid) {
        return ['check-circle-fill', 'forest'];
      }
    }
    return ['exclamation-circle-fill', 'blue'];
  }

  /**
   * A validator that checks if at least one checkbox is selected.
   * @returns {ValidatorFn} A validator that checks if at least one checkbox is selected.
   */
  atLeastOne(): ValidatorFn {
    return (control: AbstractControl) => {
      const values = control.value;
      for (let key in values) {
        if (values[key] === true) {
          return null;
        }
      }
      return { nothingSelected: true };
    };
  }

  /**
   * Takes in a form and returns an array of objects containing the name of the control in errors, the error, and the value of the control.
   * @param {FormGroup} form - the form to get the errors from.
   * @returns {object[]} - an array of objects containing the name of the controls in errors, the error, and the value of the control.
   */
  getAllFormErrors(
    form: FormGroup
  ): { control: string; error: string; value: string }[] {
    const results = [];
    for (const key in form.controls) {
      const property = form.get(key);
      if (property) {
        if (property instanceof FormGroup) {
          results.push(...this.getAllFormErrors(property));
        }
        const controlErrors = property.errors;
        for (const keyError in controlErrors) {
          results.push({
            control: key,
            error: keyError,
            value: controlErrors[keyError],
          });
        }
      }
    }
    return results;
  }
  isGeolocalisationSet() {
    var lat = this.lat;
    var long=this.lng;
    if(lat=="0" && long=="0")
      return false;

    return !!this.lat && !!this.lng;
  }
  /**
   * Send the GLN to the server.
   * @param {GLNStatus} [status="ACTIVE"] - the status of the GLN.
   * @returns None
   */
  async sendGLN(status: GLNStatus = 'ACTIVE') {
    // Checks if the operation can be done
    if (status == 'ACTIVE' && !this.GLNForm.valid) {
      return;
    }

    try {
      if (!this.isGeolocalisationSet() &&  this.GLNForm?.get('address.streetAddress')?.value !== null) {
        const fullAddress: string = this.GLNForm?.get('address.streetAddress')?.value+ ' ' +this.GLNForm?.get('address.postalCode')?.value + ' ' +this.GLNForm?.get('address.addressLocality')?.value ;
        await this.getGeoCodeAddress(fullAddress);
      }
      this.loading.startLoading('creation');
      const codeNumber =
        this.GLNForm.get("organisationCode")?.value ===
        this.organisationCode[0].value
          ? this.GLNForm.get("codeNumberSiret")?.value
          : this.GLNForm.get("codeNumberIntern")?.value;
      this.GLNForm.get("codeNumber")?.setValue(codeNumber);
      const values = { ...this.GLNForm.getRawValue() };

      // Remove some info for DRAFT
      if (status === 'DRAFT') {
        values.isPublished = false;
        values.licenceKey = null;
      }

      const gln = new GLN(values);
      gln.status = status;
      gln.latitude = this.lat;
      gln.longitude = this.lng;
      this.storage.forceGLNRefresh = true;
      if (status == 'ACTIVE' && gln.validate() || status == 'ACTIVE' && this.isMobilePhysical ) {
        if (gln.id == undefined) {
          await this.glnService.createGLN(gln); // Create a full gln
        } else {
          await this.glnService.saveGLN(gln); // Save Existing Gln with status ACTIVE
        }
        this.loading.stopLoading('creation');
        this.router.navigateByUrl('/mes-gln');
      } else if (status == 'DRAFT' && this.canSave()) {
        this.saving = true;
        const backGLN: GLNInterface = await this.glnService.createGLN(gln); // Create a draft
        this.currentGln = new GLN({ ...this.currentGln, ...backGLN });
        this.updateFormwithGLN(this.currentGln);
        this.saving = false;
      } else {
        this.notifications.addNotification(
          "Votre code GLN n'est pas valide",
          'warning'
        );
      }
    } finally {
      this.loading.stopLoading('creation');
    }
  }

  /**
   * Returns true if the form is valid and can be saved as a DRAFT.
   * @returns {boolean} - true if the form is valid and can be saved as a DRAFT.
   */


  canSave() {
    if (this.GLNForm) {
      if (
        this.currentGln &&
        this.currentGln.status &&
        this.currentGln.status !== 'DRAFT'
      ) {
        return this.GLNForm.valid;
      }
      const errors = this.getAllFormErrors(this.GLNForm);
      const hasBlockingErrors = errors.find((error) => {
        return !['required', 'invalidAddressField', 'nothingSelected'].includes(
          error.error
        );
      });
      return !(
        hasBlockingErrors || errors.find((error) => error.control === 'name')
      );
    }
    return false;
  }

  /**
   * Saves the current GLN as a DRAFT.
   * @param {GLNStatus} [status="DRAFT"] - the status of the GLN.
   * @returns None
   */
  async saveGLN(status: GLNStatus = 'DRAFT') {
    if (this.currentGln == undefined) {
      await this.sendGLN(status); // Create a Draft
      return;
    }

    if (this.canSave()) {
      const values = this.GLNForm.value as GLNInterface;
      const gln = new GLN(values);
      gln.status = this.currentGln.status;
      gln.latitude = this.lat;
      gln.longitude = this.lng;
      if (status === 'DRAFT') {
        gln.licenceKey = undefined;
        gln.isPublished = false;
      }
      try {
        this.saving = true;
        const backGLN: GLNInterface = await this.glnService.saveGLN(gln); // Save new state of existing Gln
        this.currentGln = new GLN({ ...this.currentGln, ...backGLN });
        this.updateFormwithGLN(this.currentGln);
        this.router.navigateByUrl('/mes-gln');
      } finally {
        this.saving = false;
      }
    }
  }

  /**
   * Changes the step of the form and changes somes values depending on the step.
   * @param {boolean} [next=true] - whether to go to the next step or the previous step
   * @returns None
   */
  async changeStep(next: boolean = true) {
    if (next) {
      let gcp = this.GLNForm.get('licenceKey')?.value;
      if (!gcp) {
        gcp =
          this.currentGln?.licenceKey ||
          this.gcps.filter((gcp) => gcp.value)[0]?.key ||
          null;
        this.GLNForm.get('licenceKey')?.setValue(gcp);
      }
      this.GLNForm.get('isPublished')?.setValue(true);
      this.GLNForm.get('gln')?.addValidators(Validators.required);
      await this.fetchNextGlnForGcp(gcp);
    } else {
      this.GLNForm.get('gln')?.removeValidators(Validators.required);
      this.GLNForm.get('gln')?.setValue(null);
      this.GLNForm.get('isPublished')?.setValue(false);
    }
    this.GLNForm.get('gln')?.updateValueAndValidity();
    this.step1 = !next;
  }
  /**
   *  When the user stops typing an event is started to verify the code
   * @param event
   */
  onKeySearch(event: any) {
    clearTimeout(this.timeout);
    var $this = this;
    this.timeout = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.verifyGln();
      }
    }, 1000);
  }
  async verifyGln() {
    this.glnIsUsed = false;
    this.glnIsValid = false;
    if (
      this.glnSuffix.length == this.glnRange &&
      /^\d+$/.test(this.glnSuffix)
    ) {
      this.splittedGLN[1] = this.GLNForm.get('glnSuffix')?.value;
      this.splittedGLN[2] = this.computeControlKey(
        this.splittedGLN[0] + this.splittedGLN[1]
      ).toString();
      let validationresult = (
        await this.glnService.checkGlnNumberVaidity(
          this.splittedGLN[0],
          this.splittedGLN[1]
        )
      )?.toString();

      this.glnIsValid =
        validationresult != null && validationresult.length == 13
          ? true
          : false;
      this.glnIsUsed = validationresult != null ? false : true;

      if (this.glnIsValid) this.GLNForm.get('gln')?.setValue(validationresult);
    } else {
      this.glnIsValid = false;
    }
  }

  resetGlnValidity() {}
  async getGeoCodeAddress(address: any) {
      const geoCoderRequest: google.maps.GeocoderRequest = { address: address };


     var geoCodeReponse = await firstValueFrom(
       this._geoCoder.geocode(geoCoderRequest)
     );
     switch (geoCodeReponse.status) {
       case google.maps.GeocoderStatus.OK: {
         const lat = geoCodeReponse.results[0]?.geometry.location.lat().toString();
         const lng = geoCodeReponse.results[0]?.geometry.location.lng().toString();

         this.lat = lat;
         this.lng = lng;


         break;
       }
       case google.maps.GeocoderStatus.ZERO_RESULTS: {
         this.lat  = undefined;
         this.lng= undefined;
         break;
       }
     }
  }
  computeControlKey(code: any) {
    if (
      typeof code !== 'string' ||
      code.length !== 12 ||
      !/^([0-9]*)$/.test(code)
    ) {
      throw new SyntaxError('Malformed code: should be a string of 12 numbers');
    }
    // Transforming the string code in array of numbers
    let codeArray = code.split('').map((number) => parseInt(number));
    // Sum the impair numbers
    let impairsSum = 0;
    for (let i = 1; i < code.length; i += 2) {
      impairsSum += codeArray[i];
    }
    // Multiply the result by 3
    impairsSum *= 3;
    // Sum the pair numbers
    let pairsSum = 0;
    for (let i = 0; i < code.length; i += 2) {
      pairsSum += codeArray[i];
    }
    // Sum the pairs and impairs numbers
    let finalSum = impairsSum + pairsSum;
    // Getting the rest of the modulo10
    let controlKey = 10 - (finalSum % 10);
    // If the final result is 10, the key is 0
    let finalResult = controlKey === 10 ? 0 : controlKey;
    return finalResult.toString();
  }

  removeInvalidCharsFromSuffix(event: any) {
    console.log('====> ', event.key);
    if (
      event.target?.value.length > 12 - this.splittedGLN[0].length ||
      /^\d+$/.test(event.target.value) != true
    ) {
      event.preventDefault();
        }
    }

    AddressChange(address: any) {
       this.streetNumber = '';
       this.GLNForm?.get('address.streetAddress')?.setValue('');
       this.GLNForm?.get('address.countryCode')?.setValue('');
       this.GLNForm?.get('address.addressLocality')?.setValue('');
       this.GLNForm?.get('address.postalCode')?.setValue('');

       this.lat = address.geometry.location.lat().toString();
       this.lng = address.geometry.location.lng().toString();

       for (const addressComponent of address.address_components as google.maps.GeocoderAddressComponent[]) {
         const type = addressComponent.types[0];

         switch (type) {
           case 'street_number': {
             this.streetNumber = `${addressComponent.long_name + ' '}`;
             break;
           }
           case 'route': {
             this.GLNForm?.get('address.streetAddress')?.setValue(`${this.streetNumber += addressComponent.long_name}`)
             break;
           }
           case 'country': {
             this.GLNForm?.get('address.countryCode')?.setValue(`${addressComponent.short_name}`)
             if (this.currentGln && this.currentGln.address && this.currentGln.address.countryCode) {
               this.countryName = countryList.filter(
                 (country) =>
                   this.currentGln && country['Code alpha-2'] === this.currentGln.address?.countryCode
               )[0]['wording-fr'];
             }
             break;
           }
           case 'locality': {
             this.GLNForm?.get('address.addressLocality')?.setValue(`${addressComponent.long_name}`)
             break;
           }
           case 'postal_code': {
             this.GLNForm?.get('address.postalCode')?.setValue(`${addressComponent.long_name}`)
             break;
           }
         }
       }

    }

      }
